import React from "react";


const SalesHeader = ({ title, subtitle, color = "#333" }) => {
    return (
        <div className="cards" style={{ borderTop: 10 + "px solid " + color }} >
            <div  >
                <div className="headers">
                    <div>
                        <h1 className="Title" style={{ backgroundColor: color }} >{title}</h1>
                        <h5 className="Subtitle">{subtitle}</h5>
                    </div>

                </div>
            </div>
        </div>
    );
};



export default SalesHeader